/* eslint-disable complexity */
import React from 'react';
import { useUser } from '@unisporkal/user';
import styles from './LicenseForm.module.scss';
import AssetOptions from '../../AssetOptions/AssetOptions';
import LicenseMessage from '../../Messages/LicenseMessage/LicenseMessage';
import AgencyUnlimitedLicenseMessage from '../../Messages/AgencyUnlimitedLicenseMessage/AgencyUnlimitedLicenseMessage';
import AssetSizes from '../../AssetSizes/AssetSizes';
import VideoTemplate from '../../VideoTemplate/VideoTemplate';
import LimitedUseProductsCallout from '../../LimitedUseProductsCallout/LimitedUseProductsCallout';
import Price from '../../Price/Price';
import MiniDownloadHistory from '../../MiniDownloadHistory/MiniDownloadHistory';
import useSelectedIndex from '../../../../hooks/stateful/useSelectedIndex';
import useOnLoad from '../../../../hooks/queries/useOnLoad';
import ProductSchema from '../../../seo/ProductSchema';
import { useAsset } from '../../../../hooks/stateful/useAsset';
import { useAcquisitionType } from '../../../../hooks/stateful/useAcquisitionType';
import acquisitionTypes from '../../../../support/acquisitionTypes';

const LicenseForm = () => {
  const { selectedOption } = useSelectedIndex();
  const user = useUser();

  // The useAsset hook is exclusively used by the ProductSchema component.
  // To avoid unnecessary re-renders, the LicenseForm component is the most appropriate high-level component to render the ProductSchema.
  const {
    asset: { isImage, isVideoTemplate, imageUrls = {} },
  } = useAsset();

  const { availableTypes, setAcquisitionType } = useAcquisitionType();

  const { response: { config: { isAgencyUnlimitedCreativeBuyer } = {} } = {} } =
    useOnLoad();

  const hasDownloadType = availableTypes.some(
    (item) => item.type === acquisitionTypes.DOWNLOAD
  );

  const showCreativeBuyerMessage =
    Boolean(isAgencyUnlimitedCreativeBuyer) && hasDownloadType;

  const showProductSchema = () => {
    const hasRequiredImageUrl = imageUrls?.image612;

    const hasPriceOptions =
      selectedOption?.sizes !== undefined && selectedOption.sizes.length > 0;

    return isImage() && hasPriceOptions && user.isBot && hasRequiredImageUrl;
  };

  return (
    <div className={styles.container}>
      <AssetOptions />
      {showCreativeBuyerMessage && (
        <AgencyUnlimitedLicenseMessage
          setAcquisitionType={setAcquisitionType}
        />
      )}
      <LicenseMessage />
      {!isVideoTemplate() && <AssetSizes />}
      {isVideoTemplate() && <VideoTemplate />}
      <LimitedUseProductsCallout />
      <Price />
      <MiniDownloadHistory />
      {showProductSchema() ? (
        <ProductSchema size={selectedOption.sizes} />
      ) : null}
    </div>
  );
};

export default LicenseForm;
